<app-modal-container
  [buttons]="modalButtons"
  (closeButtonClicked)="confirm.emit()">
  <app-company-one-metric-comparison-chart *ngIf="forComparisonTab" class="width-70vw" [metric]="metric" [metricGroupName]="metricGroupName" [selectedCompany]="selectedCompany">
  </app-company-one-metric-comparison-chart>
  <app-company-one-metric-chart *ngIf="!forComparisonTab" class="width-70vw" [metric]="metric" [metricGroupName]="metricGroupName"  [selectedCompany]="selectedCompany">
  </app-company-one-metric-chart>
</app-modal-container>
